/**
 * AssetCAST Role Constants
 * Centralized role definitions for consistent usage across the application
 */

export const ROLES = {
  VIEWER: 'assetcast_viewer',
  DATA_ADMIN: 'assetcast_data_admin',
  DATA_MANAGER: 'assetcast_data_manager',
} as const;

export type RoleValue = (typeof ROLES)[keyof typeof ROLES];
